import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';
import { useState } from 'react';

type ConfirmResetMagicLinksModalProps = {
  open: boolean;
  onClose: () => void;
  onResetMagicLinks?: () => void;
};

const ConfirmResetMagicLinksModal = ({ open, onClose, onResetMagicLinks }: ConfirmResetMagicLinksModalProps) => {
  const [regenerating, setRegenerating] = useState(false);

  const handleOnResetMagicLinks = () => {
    setRegenerating(true);
    if (onResetMagicLinks) {
      onResetMagicLinks();
    }
    setRegenerating(false);
    onClose();
  };

  return (
    <Modal
      RenderHeaderContent={() => (
        <Container className="padding-h-40 padding-t-24" borderRadius="12px 12px 0 0">
          <Text clamp={2} whiteSpace="wrap" tag="h3" color="var(--gray-100)" className="H3 padding-b-8">
            Regenerate Magic Links
          </Text>
        </Container>
      )}
      RenderFooterContent={() => (
        <Container borderRadius="0 0 12px 12px" className="flex fd-row jc-flex-end ai-center padding-16">
          <Button
            className="L1 padding-v-8 padding-h-16 margin-r-8"
            backgroundColor="var(--gray-700)"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            width="150px"
            className="flex ai-center padding-v-8 padding-h-16"
            onClick={handleOnResetMagicLinks}
            disabled={regenerating}
            backgroundColor={getThemeColorCSSVariable()}
            hoverOpacity={0.8}
          >
            <Text
              className="L1"
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
            >
              Regenrate Links
            </Text>
          </Button>
        </Container>
      )}
      open={open}
      onRequestClose={onClose}
      customSize={{
        width: '500px',
        maxWidth: '500px',
        height: 'auto',
        minHeight: 'auto',
        maxHeight: 'auto',
      }}
    >
      <Container className="padding-h-40 padding-b-24">
        <Text tag="p" color="var(--gray-300)" className="P2">
          Are you sure you want to regenerate magic links for the selected user? This will make any existing links for
          the selected users unusable and cannot be undone.
        </Text>
      </Container>
    </Modal>
  );
};

export default ConfirmResetMagicLinksModal;
